<template>
    <div v-if="sticker.tts && sticker.tts.bounds" class="base-image"
        :class="[list && 'mt-1']"
        :style="{ backgroundImage: `url(${stickerImageSrc})`, minHeight: `${stickerDimensions.baseHeight}px`, minWidth: `${stickerDimensions.baseWidth}px`, maxHeight: `${stickerDimensions.baseHeight}px`, maxWidth: `${stickerDimensions.baseWidth}px`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', opacity: fade ? 0.5 : 1 }">

        <!-- Set Eye Image -->

        <div v-if="sticker.tts.isEyeEnabled && sticker.tts.eyeImage && sticker.tts.bounds" :style="{
            position: 'absolute',
            width: '100%',
            height: '100%',
        }">
            <div :style="{
                position: 'absolute',
                backgroundImage: `url(${actions.getImage('eyes', sticker.tts.eyeImage)})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center center',
                zIndex: 4,
                transform: sticker.tts.isEyeFlipped ? `rotate(${sticker.tts.position.eyeAngle}deg) scaleX(-1)` : `rotate(${sticker.tts.position.eyeAngle}deg) scaleX(1)`,
                left: `${((sticker.tts.bounds.eyeX / 250) * 100)}%`,
                top: `${(sticker.tts.bounds.eyeY / 300) * 100}%`,
                width: `${(sticker.tts.bounds.eyeW / 100) * stickerDimensions.percentX}px`,
                height: `${(sticker.tts.bounds.eyeH / 100) * stickerDimensions.percentY}px`,
            }"></div>
        </div>

        <!-- Set Animated Mouth Image -->

        <div v-if="sticker.tts.isMouthEnabled && sticker.tts.mouthImage" :style="{
            position: 'absolute',
            width: '100%',
            height: '100%',
        }">
            <div :style="{
                position: 'absolute',
                backgroundImage: `url(${actions.getImage('mouth', sticker.tts.mouthImage)})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center center',
                zIndex: 4,
                transform: sticker.tts.isMouthFlipped ? `rotate(${sticker.tts.position.mouthAngle}deg) scaleX(-1)` : `rotate(${sticker.tts.position.mouthAngle}deg) scaleX(1)`,
                left: `${((sticker.tts.bounds.mouthX / 250) * 100)}%`,
                top: `${(sticker.tts.bounds.mouthY / 300) * 100}%`,
                width: `${(sticker.tts.bounds.mouthW / 100) * stickerDimensions.percentX}px`,
                height: `${(sticker.tts.bounds.mouthH / 100) * stickerDimensions.percentY}px`,
            }"></div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from '@/store';
import { getHostedAssetPath } from '@/utils/config';

export default {
    props: {
        sticker: {
            type: Object,
            default: null
        },
        fade: {
            type: Boolean,
            default: false
        },
        list: {
            type: Boolean,
            default: false
        },
        popupMd: {
            type: Boolean,
            default: false
        },
        width: {
            type: Number,
            default: null
        },
        height: {
            type: Number,
            default: null
        },
        percent: {
            type: Number,
            default: null
        },
        percentX: {
            type: Number,
            default: null
        },
        percentY: {
            type: Number,
            default: null
        }
    },

    setup(props) {
        const store = useStore();

        const stickerImageSrc = computed(() => {
            return getHostedAssetPath() + '/' + props.sticker.tts.baseImage;
        })

        const isMobile = computed(() => {
            return store.state.isMobile;
        });

        const bitsCreditAmount = computed(() => {
            return store.state.bitsCreditAmount;
        });

        const panelSize = computed(() => {
            return store.state.size;
        });

        const stickerDimensions = computed(() => {
            const dimensions = {
                baseWidth: 54,
                baseHeight: 65,
                assetPercentage: 21.6,
                percentX: 21.6,
                percentY: 21.6
            }

            if (props.list) {
                if (panelSize.value === 'sm') {
                    if (isMobile.value) {
                        dimensions.baseWidth = 60;
                        dimensions.baseHeight = 72;
                        dimensions.assetPercentage = 24;
                        dimensions.percentX = 24;
                        dimensions.percentY = 24;
                    }

                    // if (isMobile.value && bitsCreditAmount.value > 0) {
                    //     dimensions.baseWidth = 54;
                    //     dimensions.baseHeight = 65;
                    //     dimensions.assetPercentage = 21.6;
                    // }
                } else {
                    // If Component View
                    if (panelSize.value === 'md' && bitsCreditAmount.value < 1) {
                        dimensions.baseWidth = 67.5;
                        dimensions.baseHeight = 81;
                        dimensions.assetPercentage = 27;
                        dimensions.percentX = 27;
                        dimensions.percentY = 27;
                    }

                    // If Component View and Credit Bits Exists
                    if (panelSize.value === 'md' && bitsCreditAmount.value > 0) {
                        dimensions.baseWidth = 61.5;
                        dimensions.baseHeight = 74;
                        dimensions.assetPercentage = 24.6;
                        dimensions.percentX = 24.6;
                        dimensions.percentY = 24.6;
                    }
                }
            }

            if (panelSize.value === 'md' && props.popupMd) {
                dimensions.baseWidth = 83.25;
                dimensions.baseHeight = 100;
                dimensions.assetPercentage = 33.3;
                dimensions.percentX = 33.3;
                dimensions.percentY = 33.3;
            }

            if (props.width && props.height && props.percent) {
                dimensions.baseWidth = props.width;
                dimensions.baseHeight = props.height;
                dimensions.assetPercentage = props.percent;
                dimensions.percentX = props.percent;
                dimensions.percentY = props.percent;

                if (props.percentX && props.percentY) {
                    dimensions.percentX = props.percentX;
                    dimensions.percentY = props.percentY;
                }
            }

            return dimensions
        });

        const actions = {
            getImage(type) {
                if (type == 'eyes') {
                    return getHostedAssetPath() + '/' + props.sticker.tts.eyeImage;
                } else if (type == 'mouth') {
                    return getHostedAssetPath() + '/' + props.sticker.tts.mouthImage;
                }
            }
        }

        return {
            stickerImageSrc,
            stickerDimensions,
            isMobile,
            bitsCreditAmount,
            panelSize,
            actions
        }
    }
}
</script>

<style scoped>
.base-image {
    position: relative;
    margin: auto;
    -webkit-filter: drop-shadow(0.1rem 0.43rem rgba(0, 0, 0, 0.3));
	filter: drop-shadow(0.1rem 0.43rem rgba(0, 0, 0, 0.3));
}
</style>